/**
 * RSS Mega Menu enhancer
 * Tags desktop mega-menus (Bike / Motor / Part) and injects crisp CDN images
 * into Bike + Motor cards. Skips the mobile menu drawer.
 *
 * v2 (robust): Horizon hydrates the header after load by fetching
 * ?section_id=<header_section> and morphing the fresh server HTML into
 * <header-menu>. That wipes data-rss-mega + .rss-mega-media added at
 * DOMContentLoaded. Same happens on cart updates / theme-editor reloads.
 * So apply() is idempotent and re-runs on DOMContentLoaded, load, pageshow,
 * shopify:section:load, any DOM mutation inside the header (MutationObserver,
 * applied in the microtask before paint), and on hover/focus of a menu item.
 */
(function () {
  'use strict';

  var CDN = 'https://resurrectionspeedshop.com/cdn/shop/files/';

  var BIKE = {
    softail: {
      src: CDN + 'rss-bike-softail.png?v=16610170884653180227&width=480',
      srcset:
        CDN + 'rss-bike-softail.png?v=16610170884653180227&width=240 240w, ' +
        CDN + 'rss-bike-softail.png?v=16610170884653180227&width=360 360w, ' +
        CDN + 'rss-bike-softail.png?v=16610170884653180227&width=480 480w',
      alt: 'Softail'
    },
    dyna: {
      src: CDN + 'rss-bike-dyna.png?v=12958263392233955336&width=480',
      srcset:
        CDN + 'rss-bike-dyna.png?v=12958263392233955336&width=240 240w, ' +
        CDN + 'rss-bike-dyna.png?v=12958263392233955336&width=360 360w, ' +
        CDN + 'rss-bike-dyna.png?v=12958263392233955336&width=480 480w',
      alt: 'Dyna'
    },
    touring: {
      src: CDN + 'rss-bike-touring.png?width=480',
      srcset:
        CDN + 'rss-bike-touring.png?width=240 240w, ' +
        CDN + 'rss-bike-touring.png?width=360 360w, ' +
        CDN + 'rss-bike-touring.png?width=480 480w',
      alt: 'Touring'
    },
    sportster: {
      src: CDN + 'rss-bike-sportster.png?v=1851907716358704688&width=480',
      srcset:
        CDN + 'rss-bike-sportster.png?v=1851907716358704688&width=240 240w, ' +
        CDN + 'rss-bike-sportster.png?v=1851907716358704688&width=360 360w, ' +
        CDN + 'rss-bike-sportster.png?v=1851907716358704688&width=480 480w',
      alt: 'Sportster'
    },
    fxr: {
      src: CDN + 'rss-bike-fxr.png?v=412943448333137184&width=480',
      srcset:
        CDN + 'rss-bike-fxr.png?v=412943448333137184&width=240 240w, ' +
        CDN + 'rss-bike-fxr.png?v=412943448333137184&width=360 360w, ' +
        CDN + 'rss-bike-fxr.png?v=412943448333137184&width=480 480w',
      alt: 'FXR'
    }
  };

  var MOTOR = {
    evo: {
      src: CDN + 'rss-motor-evo.png?v=6698942281669514848&width=480',
      srcset:
        CDN + 'rss-motor-evo.png?v=6698942281669514848&width=240 240w, ' +
        CDN + 'rss-motor-evo.png?v=6698942281669514848&width=360 360w, ' +
        CDN + 'rss-motor-evo.png?v=6698942281669514848&width=480 480w',
      alt: 'Evo'
    },
    'twin-cam': {
      src: CDN + 'rss-motor-twincam.png?v=13832537661801690171&width=480',
      srcset:
        CDN + 'rss-motor-twincam.png?v=13832537661801690171&width=240 240w, ' +
        CDN + 'rss-motor-twincam.png?v=13832537661801690171&width=360 360w, ' +
        CDN + 'rss-motor-twincam.png?v=13832537661801690171&width=480 480w',
      alt: 'Twin Cam'
    },
    twincam: null, // alias filled below
    m8: {
      src: CDN + 'rss-motor-m8.png?v=3262562481583116079&width=480',
      srcset:
        CDN + 'rss-motor-m8.png?v=3262562481583116079&width=240 240w, ' +
        CDN + 'rss-motor-m8.png?v=3262562481583116079&width=360 360w, ' +
        CDN + 'rss-motor-m8.png?v=3262562481583116079&width=480 480w',
      alt: 'Milwaukee-Eight'
    }
  };
  MOTOR.twincam = MOTOR['twin-cam'];

  function handleFromHref(href) {
    if (!href) return '';
    try {
      var path = href.split('?')[0].replace(/\/+$/, '');
      var parts = path.split('/');
      return (parts[parts.length - 1] || '').toLowerCase();
    } catch (e) {
      return '';
    }
  }

  function kindFromTitle(title) {
    var t = (title || '').trim().toLowerCase();
    if (t.indexOf('bike') !== -1) return 'bike';
    if (t.indexOf('motor') !== -1) return 'motor';
    if (t.indexOf('part') !== -1) return 'part';
    return '';
  }

  function injectImage(link, asset) {
    if (!asset) return;
    var existing = link.querySelector('.rss-mega-media');
    if (existing) {
      var cur = existing.querySelector('img');
      if (cur && cur.getAttribute('src') === asset.src) return;
      existing.parentNode.removeChild(existing);
    }
    var media = document.createElement('span');
    media.className = 'rss-mega-media';
    media.setAttribute('aria-hidden', 'true');
    var img = document.createElement('img');
    img.src = asset.src;
    img.srcset = asset.srcset;
    img.sizes = '(max-width: 1200px) 18vw, 220px';
    img.alt = '';
    img.width = 480;
    img.height = 360;
    img.loading = 'eager';
    img.decoding = 'async';
    media.appendChild(img);
    link.appendChild(media);
  }

  function assetFor(map, link) {
    var asset = map[handleFromHref(link.getAttribute('href'))];
    if (asset) return asset;
    var text = (link.textContent || '').trim().toLowerCase();
    if (text.indexOf('milwaukee') !== -1 || text === 'm8') return map.m8;
    if (text.indexOf('twin') !== -1) return map['twin-cam'];
    if (text.indexOf('evo') !== -1) return map.evo;
    if (text.indexOf('softail') !== -1) return map.softail;
    if (text.indexOf('dyna') !== -1) return map.dyna;
    if (text.indexOf('touring') !== -1) return map.touring;
    if (text.indexOf('sportster') !== -1) return map.sportster;
    if (text.indexOf('fxr') !== -1) return map.fxr;
    return null;
  }

  function enhanceSubmenu(item, kind) {
    var submenu = null;
    for (var c = 0; c < item.children.length; c++) {
      if (item.children[c].classList.contains('menu-list__submenu')) { submenu = item.children[c]; break; }
    }
    if (!submenu) submenu = item.querySelector('.menu-list__submenu');
    if (!submenu) return;
    if (submenu.getAttribute('data-rss-mega') !== kind) submenu.setAttribute('data-rss-mega', kind);
    if (kind !== 'bike' && kind !== 'motor') return;
    var map = kind === 'bike' ? BIKE : MOTOR;
    var links = submenu.querySelectorAll('a.mega-menu__link');
    for (var i = 0; i < links.length; i++) {
      var a = assetFor(map, links[i]);
      if (a) injectImage(links[i], a);
    }
  }

  function titleOf(item) {
    var el = item.querySelector('.menu-list__link-title');
    if (el && el.closest('.menu-list__submenu')) el = null;
    if (!el) {
      var a = item.querySelector('a.menu-list__link, a[aria-haspopup]');
      return a ? a.textContent : '';
    }
    return el.textContent;
  }

  var applying = false;
  function apply() {
    if (applying) return;
    applying = true;
    try {
      // Desktop header menu(s) only, never the drawer
      var menus = document.querySelectorAll('header-menu, .header-menu');
      for (var m = 0; m < menus.length; m++) {
        var menu = menus[m];
        if (menu.closest('menu-drawer, .menu-drawer, header-drawer, .header-drawer')) continue;
        var items = menu.querySelectorAll('.menu-list__list-item');
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          if (item.closest('.menu-list__submenu, menu-drawer, .menu-drawer')) continue;
          var kind = kindFromTitle(titleOf(item));
          if (kind) enhanceSubmenu(item, kind);
        }
      }
    } catch (e) {
      if (window.console) console.warn('[rss-mega-menu]', e);
    } finally {
      applying = false;
    }
  }

  function touchesHeader(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.closest && node.closest('header-menu, .header-menu, header-component, #header-group, .header-section, header')) return true;
    return !!(node.querySelector && node.querySelector('header-menu, .header-menu'));
  }

  function needsApply() {
    var subs = document.querySelectorAll('header-menu .menu-list__submenu, .header-menu .menu-list__submenu');
    for (var i = 0; i < subs.length; i++) {
      var s = subs[i];
      if (s.closest('menu-drawer, .menu-drawer')) continue;
      var li = s.parentElement;
      var kind = li ? kindFromTitle(titleOf(li)) : '';
      if (!kind) continue;
      if (s.getAttribute('data-rss-mega') !== kind) return true;
      if ((kind === 'bike' || kind === 'motor') && s.querySelector('a.mega-menu__link:not(:has(.rss-mega-media))')) return true;
    }
    return false;
  }

  function onMutations(list) {
    if (applying) return;
    for (var i = 0; i < list.length; i++) {
      var r = list[i];
      if (touchesHeader(r.target)) {
        // Runs in the mutation microtask, before the next paint: no flash of the plain list
        try { if (needsApply()) apply(); } catch (e) { apply(); }
        return;
      }
    }
  }

  function init() {
    apply();
    if (window.__rssMegaObserver) return;
    if (typeof MutationObserver !== 'undefined') {
      window.__rssMegaObserver = new MutationObserver(onMutations);
      window.__rssMegaObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-rss-mega', 'class']
      });
    }
    var onIntent = function (e) {
      var t = e.target;
      if (t && t.nodeType === 1 && t.closest && t.closest('header-menu .menu-list__list-item, .header-menu .menu-list__list-item')) apply();
    };
    document.addEventListener('pointerover', onIntent, true);
    document.addEventListener('mouseover', onIntent, true);
    document.addEventListener('focusin', onIntent, true);
    window.addEventListener('load', apply);
    window.addEventListener('pageshow', apply);
    document.addEventListener('shopify:section:load', apply);
    document.addEventListener('shopify:section:select', apply);
  }

  if (window.__rssMegaInit) { apply(); return; }
  window.__rssMegaInit = true;
  window.rssMegaMenuApply = apply;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
